// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"83":"0902c8195c276fdb5be4","96":"2ace51916b00a998810e","418":"630b01870998d8a5f4ad"}[chunkId] + ".css";
};